import { Union, Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { list_type, unit_type, option_type, int32_type, string_type, tuple_type, lambda_type, union_type, record_type, class_type, float64_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { ofArray } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { Model$1_$reflection, Msg$1_$reflection } from "../../Wizard/WizardTypes.js";
import { Model_$reflection, OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1 } from "./CoreFormFileManagement/CoreFormFileTypes.js";
import { Msg$3_$reflection } from "../../Common/InboundOutbound.js";
import { StudyViewModelModule_ValidatedFields_$reflection, StudyViewModel_$reflection } from "../../RAWMap.Models/View/Study.js";
import { ErrorMessage_$reflection } from "../../RAWMap.Models/ErrorMessage.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.3/Result.js";
import { Common_DeidentificationStatus_$reflection, Common_StudyStatus_$reflection } from "../../RAWMap.Models/Common.js";
import { InstitutionViewModel_$reflection } from "../../RAWMap.Models/View/Institution.js";
import { Progress_ProgressStatus$1_$reflection } from "../../Common/JsInteropGeneral.js";
import { S3Context_$reflection } from "../../Common/AwsCommon.js";
import { UserRole_$reflection } from "../../RAWMap.Models/Security.js";

export class DeidentificationTimerConfig extends Record {
    constructor(timerId, requestId) {
        super();
        this.timerId = timerId;
        this.requestId = requestId;
    }
}

export function DeidentificationTimerConfig_$reflection() {
    return record_type("Client.Study.CoreForm.Types.DeidentificationTimerConfig", [], DeidentificationTimerConfig, () => [["timerId", float64_type], ["requestId", class_type("System.Guid")]]);
}

export class WizardStep extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EnterStudyInfo", "UploadDicom"];
    }
}

export function WizardStep_$reflection() {
    return union_type("Client.Study.CoreForm.Types.WizardStep", [], WizardStep, () => [[], []]);
}

export function WizardStep_get_sequence() {
    return ofArray([new WizardStep(0, []), new WizardStep(1, [])]);
}

export function WizardStep_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? "Step 2: Upload DICOM" : "Step 1: Enter Study Info");
}

export class CancelConfirmationOutcome extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Deselect", "ReturnToDetail"];
    }
}

export function CancelConfirmationOutcome_$reflection() {
    return union_type("Client.Study.CoreForm.Types.CancelConfirmationOutcome", [], CancelConfirmationOutcome, () => [[], []]);
}

export class StudyCsvProgressStages extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Waiting", "GeneratingCsv", "Done"];
    }
}

export function StudyCsvProgressStages_$reflection() {
    return union_type("Client.Study.CoreForm.Types.StudyCsvProgressStages", [], StudyCsvProgressStages, () => [[], [], []]);
}

export function StudyCsvProgressStages_describe_6E8B2D76(stage) {
    switch (stage.tag) {
        case 1:
            return "Generating CSV";
        case 2:
            return "Done";
        default:
            return "Waiting";
    }
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "WizardMsg", "StudyDataFileManagementMsg", "SetStudyVm", "TryEditStudy", "EditStudy", "SaveStudy", "CreateStudyResult", "CreateStudyException", "EditStudyResult", "EditStudyException", "UpdateStudyStatusResult", "PoseCancelConfirmation", "CancelConfirmed", "AbortCancel", "DefaultToResearch", "TryDownloadStudyInfo", "DownloadStudyInfo", "DownloadStudyInfoResult", "DownloadStudyInfoProgress", "EnqueueForDeidentificationResult", "StartDeidentificationTimer", "DeidentificationTimerStarted", "TryStopDeidentificationTimer", "GetDeidentificationStatus", "GetDeidentificationStatusResult", "MonitorDeidentificationStatus", "Close", "UnlockStudyEdit", "UnlockStudyEditResult"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("Client.Study.CoreForm.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [["Item", Msg$1_$reflection(WizardStep_$reflection())]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", lambda_type(StudyViewModel_$reflection(), StudyViewModel_$reflection())]], [], [], [], [["Item1", union_type("Microsoft.FSharp.Core.FSharpResult`2", [StudyViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", StudyViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])], ["Item2", Model$1_$reflection(WizardStep_$reflection())]], [["Item1", class_type("System.Exception")], ["Item2", Model$1_$reflection(WizardStep_$reflection())]], [["Item1", union_type("Microsoft.FSharp.Core.FSharpResult`2", [StudyViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", StudyViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])], ["Item2", Model$1_$reflection(WizardStep_$reflection())]], [["Item1", class_type("System.Exception")], ["Item2", Model$1_$reflection(WizardStep_$reflection())]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(class_type("System.Guid"), Common_StudyStatus_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(class_type("System.Guid"), Common_StudyStatus_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", CancelConfirmationOutcome_$reflection()]], [], [], [["Item", InstitutionViewModel_$reflection()]], [["Item", StudyViewModel_$reflection()]], [["Item", StudyViewModel_$reflection()]], [["Item", tuple_type(Progress_ProgressStatus$1_$reflection(StudyCsvProgressStages_$reflection()), string_type)]], [["Item", Progress_ProgressStatus$1_$reflection(StudyCsvProgressStages_$reflection())]], [["requestId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["requestId", class_type("System.Guid")], ["queueLength", int32_type]], [["Item", DeidentificationTimerConfig_$reflection()]], [["Item", option_type(DeidentificationTimerConfig_$reflection())]], [["requestId", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(Common_DeidentificationStatus_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", option_type(Common_DeidentificationStatus_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["requestId", class_type("System.Guid")], ["queueLength", int32_type]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(class_type("System.Guid"), Common_StudyStatus_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(class_type("System.Guid"), Common_StudyStatus_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]]]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateActiveStudy", "GotCredentials"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("Client.Study.CoreForm.Types.InboundMsg", [], InboundMsg, () => [[["Item", StudyViewModel_$reflection()]], [["Item1", class_type("Fable.Import.Aws.Credentials.Credentials")], ["Item2", S3Context_$reflection()]]]);
}

export class InternalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Local", "Inbound"];
    }
}

export function InternalMsg_$reflection() {
    return union_type("Client.Study.CoreForm.Types.InternalMsg", [], InternalMsg, () => [[["Item", LocalMsg_$reflection()]], [["Item", InboundMsg_$reflection()]]]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StudyIdAssigned", "ActiveStudyModified", "RefreshBeforeCommand", "CancelSelection"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("Client.Study.CoreForm.Types.OutboundMsg", [], OutboundMsg, () => [[["studyId", class_type("System.Guid")]], [["Item", StudyViewModel_$reflection()]], [["Item", tuple_type(class_type("System.Guid"), lambda_type(StudyViewModel_$reflection(), list_type(lambda_type(lambda_type(InternalMsg_$reflection(), unit_type), unit_type))))]], []]);
}

export class MsgCore extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Internal", "External"];
    }
}

export function MsgCore_$reflection() {
    return union_type("Client.Study.CoreForm.Types.MsgCore", [], MsgCore, () => [[["Item", InternalMsg_$reflection()]], [["Item", OutboundMsg_$reflection()]]]);
}

export function wrapLocalMsg(msg) {
    return new MsgCore(0, [new InternalMsg(0, [msg])]);
}

export class DeidentificationState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotStarted", "Zipping", "FileUploading", "Pending", "Completed"];
    }
}

export function DeidentificationState_$reflection() {
    return union_type("Client.Study.CoreForm.Types.DeidentificationState", [], DeidentificationState, () => [[], [], [], [], [["Item", Common_DeidentificationStatus_$reflection()]]]);
}

export class WizardModifier extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Busy"];
    }
}

export function WizardModifier_$reflection() {
    return union_type("Client.Study.CoreForm.Types.WizardModifier", [], WizardModifier, () => [[]]);
}

export class ModeCore extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["List", "Create", "Edit", "Detail", "DownloadCsv"];
    }
}

export function ModeCore_$reflection() {
    return union_type("Client.Study.CoreForm.Types.ModeCore", [], ModeCore, () => [[], [["Item1", Model$1_$reflection(WizardStep_$reflection())], ["Item2", option_type(WizardModifier_$reflection())]], [["Item1", Model$1_$reflection(WizardStep_$reflection())], ["Item2", option_type(WizardModifier_$reflection())]], [], [["Item", Progress_ProgressStatus$1_$reflection(StudyCsvProgressStages_$reflection())]]]);
}

export class PatientInfo extends Record {
    constructor(patientInfoId, patientInstitution) {
        super();
        this.patientInfoId = patientInfoId;
        this.patientInstitution = patientInstitution;
    }
}

export function PatientInfo_$reflection() {
    return record_type("Client.Study.CoreForm.Types.PatientInfo", [], PatientInfo, () => [["patientInfoId", class_type("System.Guid")], ["patientInstitution", InstitutionViewModel_$reflection()]]);
}

export function PatientInfo_get_patientInfoId_() {
    return [(m) => m.patientInfoId, (v) => ((m_1) => (new PatientInfo(v, m_1.patientInstitution)))];
}

export function PatientInfo_get_patientInstitution_() {
    return [(m) => m.patientInstitution, (v) => ((m_1) => (new PatientInfo(m_1.patientInfoId, v)))];
}

export class ModelCore extends Record {
    constructor(Mode, EditStudyVm, ValidatedEditStudyVm, SelectedStudy, FileUpdateArgs, StudyDataFileManagement, ActivePatientInfo, MaybeDeidentificationTimerConfig, DeidentificationState, DeidentificationRequestInfo, CancellationOutcome, UserRole) {
        super();
        this.Mode = Mode;
        this.EditStudyVm = EditStudyVm;
        this.ValidatedEditStudyVm = ValidatedEditStudyVm;
        this.SelectedStudy = SelectedStudy;
        this.FileUpdateArgs = FileUpdateArgs;
        this.StudyDataFileManagement = StudyDataFileManagement;
        this.ActivePatientInfo = ActivePatientInfo;
        this.MaybeDeidentificationTimerConfig = MaybeDeidentificationTimerConfig;
        this.DeidentificationState = DeidentificationState;
        this.DeidentificationRequestInfo = DeidentificationRequestInfo;
        this.CancellationOutcome = CancellationOutcome;
        this.UserRole = UserRole;
    }
}

export function ModelCore_$reflection() {
    return record_type("Client.Study.CoreForm.Types.ModelCore", [], ModelCore, () => [["Mode", ModeCore_$reflection()], ["EditStudyVm", StudyViewModel_$reflection()], ["ValidatedEditStudyVm", option_type(StudyViewModelModule_ValidatedFields_$reflection())], ["SelectedStudy", StudyViewModel_$reflection()], ["FileUpdateArgs", option_type(tuple_type(class_type("Fable.Import.Aws.Credentials.Credentials"), S3Context_$reflection()))], ["StudyDataFileManagement", Model_$reflection()], ["ActivePatientInfo", PatientInfo_$reflection()], ["MaybeDeidentificationTimerConfig", option_type(DeidentificationTimerConfig_$reflection())], ["DeidentificationState", DeidentificationState_$reflection()], ["DeidentificationRequestInfo", option_type(tuple_type(class_type("System.Guid"), int32_type))], ["CancellationOutcome", option_type(CancelConfirmationOutcome_$reflection())], ["UserRole", UserRole_$reflection()]]);
}

export function ModelCore_get_activePatientInfo_() {
    return [(m) => m.ActivePatientInfo, (v) => ((m_1) => (new ModelCore(m_1.Mode, m_1.EditStudyVm, m_1.ValidatedEditStudyVm, m_1.SelectedStudy, m_1.FileUpdateArgs, m_1.StudyDataFileManagement, v, m_1.MaybeDeidentificationTimerConfig, m_1.DeidentificationState, m_1.DeidentificationRequestInfo, m_1.CancellationOutcome, m_1.UserRole)))];
}

export const fieldsInvalidNotice = "One or more fields are invalid";

